import {
  resyApiPostLegacy,
} from './api-services-legacy';
import {
  amexOneDataFunctionsApi,
  annotationGet,
  itemsGet,
  resyApiDelete,
  resyApiGet,
  resyApiPatch,
  resyApiPost,
  resyBlog,
  resyOsDelete,
  resyOsGet,
  resyOsPost,
  resySurveyGet,
  resySurveyPost,
} from './api-services';

import { JSON_ENCODED } from '../constants/apiContentTypes';
import { parameterize } from '../utils';
import { inviteDetailsTransform } from './resyApiTransformer';
import {
  handlePostConsumerGuestTagsParams,
  handlePostRateReservationParams,
  handlePostUserProfileAllergiesParams,
  handlePostUserProfileLocationsParams,
  handlePostUserResetPasswordParams,
} from './api-helper';

// paths for endpoints
const ANNOUNCEMENT = '2/announcement';
const ANNOUNCEMENTS = '2/announcements';
const AMEX_OFFERS = '4/amex_offers';
const AMEX_PREFILL = '4/prefill';
const AMEX_PERSONALIZED_MARKETING_PAYLOAD = 'ReadMaskedAudienceSegmentsForResyAds.v1';
const AUTH_MOBILE_CLAIM = '3/auth/mobile/claim';
const AUTH_REFRESH = '3/auth/refresh';
const AUTH_PASSWORD = '4/auth/password';
const AUTH_CHALLENGE = '4/auth/challenge';
const AUTH_DESTROY = '4/auth/destroy';
const AUTH_EMAIL_REQUEST = '3/auth/email/request';
const AUTH_EMAIL_VERIFY = '4/auth/email/verify';
const AUTH_MOBILE = '4/auth/mobile';
const BOOKING_BOOK = '3/book';
const BOOKING_CHANGE = '3/change';
const BOOKING_CONCIERGE_BOOK = '3/concierge/book';
const BOOKING_DETAILS = '3/details';
const GOOGLE_BOOKING_DETAILS = '3/google/details';
const CANCEL = '3/cancel';
const CHEF_LISTS = (venueId) => `3/user/venues/${venueId}/chef_lists`;
const CITIES = (locationSlug, collectionSlug) => `3/cities/${locationSlug}/list/${collectionSlug}`;
const COLLECTION_SUGGESTIONS = '3/collection/suggestions';
const COLLECTION_VENUES = '3/collection/venues';
const COLLECTION_VENUES_MARKETING = '3/marketing/collection/venues';
const COLLECTIONS = '3/collections';
const COLLECTIONS_MARKETING = '3/marketing/collections';
const CONCIERGE_CANCEL = '3/concierge/cancel';
const CONCIERGE_RESERVATIONS = '3/concierge/reservations';
const CONCIERGE_SPECIAL_REQUEST = '3/concierge/special_request';
const CONFIG = '2/config';
const CONSUMER_GUEST_TAGS = '1/consumer/guest/tags';
const CONSUMER_NOTES = '1/consumer/notes';
const CONSUMER_NOTES_LIST = '1/consumer/notes/list';
const CONSUMER_RESERVATION_PARTY_TAGS = (partyId) => `1/consumer/reservation/${partyId}/tags`;
const CONTACT = '2/contact';
const EVENT = '3/event';
const EVENTS = '3/events';
const EVENTS_LOCATION = '3/events/location';
const EVENTS_PACKAGES = '3/event/packages';
const EVENTS_UPCOMING = '3/events/upcoming';
const FAVORITES = '3/user/favorites';
const LISTS = '3/user/lists';
const LIST_VENUES_BY_USER = '/3/user/lists/venue_ids';
const LISTS_BY_VENUE = (venueId) => `3/user/lists/venue/${venueId}`;
const LISTS_BY_LIST_ID = (listId) => `3/user/lists/${listId}`;
const LISTS_BY_LIST_ID_SHARE = (listId) => `3/user/lists/${listId}/share`;
const LISTS_BY_SHARE_SLUG = (slug) => `3/user/lists/${slug}/view`;
const LISTS_COPY_BY_SHARE_SLUG = (slug) => `3/user/lists/${slug}/copy`;
const LIST_FOLLOW_BY_SHARE_SLUG = (slug) => `/3/user/lists/${slug}/follow`;
const FINDER = '4/find';
const FORGOT_PASSWORD = '2/forgot_password';
const GEO_IP = '3/geoip';
const GOOGLE_STATIC_MAPS_URL_SIGN = '3/google/static_maps/url/sign';
const HOSPITALITY = '2/hospitality';
const LOCATION = '3/location';
const LOCATION_CONFIG = '3/location/config';
const LOCATION_CUISINES = '3/location/cuisines';
const MENUS_BY_TEMPLATE = (venueId, templateId) => `1/${venueId}/templates/${templateId}/menus`;
const NOTIFIES = '2/notifies';
const NOTIFY_2 = '2/notify';
const NOTIFY_3 = '3/notify';
const OPTIMIZELY_FEATURE_FLAGS = '4/optimizely/feature-flags';
const OPTIMIZELY_EVENT_TRACKING = (slug) => `4/optimizely/track-event?eventKey=${slug}`;
const PARTY_GUEST = '2/party/guest';
const PARTY_INVITE_CONFIRM = '3/party/invite/confirm';
const PARTY_INVITE_DECLINE = '3/party/invite/decline';
const PARTY_INVITE_DETAILS = '3/party/invite/details';
const PARTY_INVITE_GUESTS = '2/party/invite/guests';
const PROXY_OS_PREPAY = '3/proxy/os/prepay';
const RATE_RESERVATION = '3/rate/reservation';
const RESERVATION_ADDRESS = '2/reservation/address';
const RESERVATION_SPECIAL_REQUEST = '2/reservation/special_request';
const RESY_BLOG = '/wp-json/wp/v2/pages/4209';
const RESY_BLOG_LOCATION = '/wp-json/wp/v2/city_landing';
const RESY_BLOG_VENUE = '/wp-json/wp/v2/venue';
const STRIPE_PAYMENT_METHOD = '/3/stripe/payment_method';
const STRIPE_SETUP_INTENT = '/3/stripe/setup_intent';
const STRIPE_CONCIERGE_SETUP_INTENT = '/3/concierge/stripe/setup_intent';
const SURVEY = (surveyCode) => `/api/1/survey/${surveyCode}/`;
const TAGS = '1/tags';
const USER = '2/user';
const USER_LOCATION = '2/user/location';
const USER_PAYMENT_METHOD = '2/user/payment_method';
const USER_PROFILE_ALLERGIES = '2/user/profile/allergies';
const USER_PROFILE_CONCIERGE_REGISTRATION = '2/user/profile/concierge/registration';
const USER_PROFILE_EMAIL_OPTOUT = '2/user/profile/email/opt_out';
const USER_PROFILE_LOCATIONS = '2/user/profile/locations';
const USER_PROFILE_RATING_OPTOUT = '2/user/profile/rating/opt_out';
const USER_REGISTRATION = '4/user/registration';
const USER_RESERVATION = '2/user/reservation';
const USER_RESERVATIONS = '3/user/reservations';
const USER_RESET_PASSWORD = '2/user/reset_password';
const VENUE = '3/venue';
const VENUE_CALENDAR = '4/venue/calendar';
const VENUE_SEARCH = '3/venuesearch/search';
const VENUE_SEARCH_CONFIG = '3/venuesearch/config';
const VENUES = '2/venues';
const VENUES_BOOK_TONIGHT = '3/venues/book_tonight';
const VENUES_3 = '3/venues';
const VENUES_TOP = '2/venues/top';
const VENUES_LISTS = (venueId) => `3/user/venues/${venueId}/lists`;
const VENUE_RECOMMENDATIONS = (venueId) => `/4/recommendations/${venueId}/availability`;
const VENUES_TYPE = (type) => `3/venues/${type}`;
const AMEX_PLATINUM_VENUES = '3/collection/platinum';

// API GET
// https://github.com/resy/api#get
export const getAnnouncements = (data) => resyApiGet().get(ANNOUNCEMENTS, { params: data });
export const postAnnouncementsList = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(ANNOUNCEMENTS, data);
export const getAuthDestroy = () => resyApiGet({ withCredentials: true }).get(AUTH_DESTROY);
export const getBookDetails = (data) => resyApiGet().get(BOOKING_DETAILS, { params: data });
export const getChefLists = (venueId) => resyApiGet().get(CHEF_LISTS(venueId));
export const getCityCollections = ({ locationSlug, ...params }) => Promise.all([
  resyApiGet().get(CITIES(locationSlug, 'climbing'), { params }),
  resyApiGet().get(CITIES(locationSlug, 'top-rated'), { params }),
  resyApiGet().get(CITIES(locationSlug, 'new-on-resy'), { params }),
]);
// https://github.com/resy/api#get-31
export const getCollections = (data) => resyApiGet().get(COLLECTIONS, { params: data });
export const getCollectionsMarketing = (data) => resyApiGet().get(COLLECTIONS_MARKETING, { params: data });
// https://github.com/resy/api#3collectionsuggestions
export const getCollectionSuggestions = (data = {}) => resyApiGet().get(COLLECTION_SUGGESTIONS, {
  params: {
    location_id: data.locationId,
    day: data.selectedDate,
    party_size: data.partySize,
  },
});
// https://github.com/resy/api#3collectionvenues
export const getCollectionVenues = (data) => resyApiGet().get(COLLECTION_VENUES, { params: data });
export const getCollectionVenuesForMarketing = (data) => resyApiGet().get(COLLECTION_VENUES_MARKETING, { params: data });
// https://github.com/resy/api#get-6
export const getConfig = (data) => resyApiGet().get(CONFIG, { params: data });
export const getConsumerGuestTags = () => resyOsGet().get(CONSUMER_GUEST_TAGS);
export const getConsumerReservationPartyTags = (partyId) => resyOsGet().get(CONSUMER_RESERVATION_PARTY_TAGS(partyId));
export const getEvent = (data) => resyApiGet().get(EVENT, { params: data });
export const postEvent = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(EVENT, data);
export const getEvents = (data) => resyApiGet().get(EVENTS, { params: data });
export const getEventsLocation = (data) => resyApiGet().get(EVENTS_LOCATION, { params: data });
export const getEventsPackages = (data) => resyApiGet().get(EVENTS_PACKAGES, { params: data });
export const getEventsUpcoming = (data) => resyApiGet().get(EVENTS_UPCOMING, { params: data });
export const getFinder = (data) => resyApiGet().get(FINDER, { params: data });
export const postFinderList = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(FINDER, data);
export const getFavorites = (data) => resyApiGet().get(FAVORITES, { params: data });
export const getGoogleStaticMapUrlSign = (data) => resyApiGet().get(GOOGLE_STATIC_MAPS_URL_SIGN, { params: data });
export const getIpdata = () => resyApiGet().get(GEO_IP);
export const getLists = (data) => resyApiGet().get(LISTS, { params: data });
export const getListsByVenue = (venueId) => resyApiGet().get(LISTS_BY_VENUE(venueId));
export const getListVenues = ({ listId, ...data }) => resyApiGet().get(`${LISTS}/${listId}`, { params: data });
export const getListVenuesByUser = () => resyApiGet().get(LIST_VENUES_BY_USER);
export const getLocation = (data) => resyApiGet().get(LOCATION, { params: data });
export const getLocationConfig = (data) => resyApiGet().get(LOCATION_CONFIG, { params: data });
export const getListBySlug = ({ slug, ...data }) => resyApiGet().get(`${LISTS_BY_SHARE_SLUG(slug)}`, { params: data });
export const getMenusByTemplate = (venueId, templateId, data) => itemsGet().get(MENUS_BY_TEMPLATE(venueId, templateId), { params: data });
export const getPartyInviteDetails = (data) => resyApiGet()
  .get(PARTY_INVITE_DETAILS, { params: data })
  .then((response) => inviteDetailsTransform(response));
export const getProxyOsPrepay = (data = {}) => resyApiGet().get(PROXY_OS_PREPAY, { params: { web_key: data.token } });
export const getResyBlog = () => resyBlog().get(RESY_BLOG);
export const getResyBlogLocation = (code, lang) => resyBlog().get(RESY_BLOG_LOCATION, {
  params: {
    'filter[meta_key]': 'code',
    'filter[meta_value]': code,
    lang,
  },
});
export const getResyBlogVenue = (venueId) => resyBlog().get(RESY_BLOG_VENUE, {
  params: {
    'filter[meta_key]': 'resy_id',
    'filter[meta_value]': venueId,
  },
});
export const getTags = () => annotationGet().get(TAGS);
// https://github.com/resy/api#get-12
export const getUser = () => resyApiGet().get(USER);
// https://github.com/resy/api#get-18
export const getUserProfileAllergies = () => resyApiGet().get(USER_PROFILE_ALLERGIES);
export const getUserProfileConciergeRegistration = () => resyApiGet().get(USER_PROFILE_CONCIERGE_REGISTRATION);
// https://github.com/resy/api#get-19
export const getUserProfileLocations = () => resyApiGet().get(USER_PROFILE_LOCATIONS);
// https://github.com/resy/api#3userrecommendations
export const getUserRecommendations = (data) => resyApiGet().get(COLLECTION_SUGGESTIONS, { params: data });
// https://github.com/resy/api#get-23
export const getUserReservation = (data) => resyApiGet().get(USER_RESERVATION, {
  params: { ...data, location_id: data.location },
});
// https://github.com/resy/api#get-34
// https://github.com/resy/api#get-15
export const getUserReservations = (data = {}) => resyApiGet().get(
  data.book_on_behalf_of ? CONCIERGE_RESERVATIONS : USER_RESERVATIONS,
  { params: data }
);
export const getVenue = (data) => resyApiGet().get(VENUE, { params: data });
// https://github.com/resy/api#2venues
export const getVenues = (data) => resyApiGet().get(VENUES, { params: data });
export const getVenuesV3 = (data) => resyApiGet().get(VENUES_3, { params: data });
export const getVenuesBookTonight = (data) => resyApiGet().get(VENUES_BOOK_TONIGHT, { params: data });
// not documented by resy api
export const getVenueCalendar = (data) => resyApiGet().get(VENUE_CALENDAR, { params: data });
export const getVenueRecommendations = (data) => resyApiGet().get(VENUE_RECOMMENDATIONS(data.venueId), { params: data });
// https://github.com/resy/api/blob/master/README.md#get-63
export const getVenueSearchConfig = (data) => resyApiGet().get(VENUE_SEARCH_CONFIG, { params: data });
export const getVenuesTop = (data) => resyApiGet().get(VENUES_TOP, { params: data });
export const getVenuesType = (type, data) => resyApiGet().get(VENUES_TYPE(type), { params: data });
export const getAmexOffers = (data) => resyApiGet().get(AMEX_OFFERS, { params: data });
export const fetchAdsSegmentData = ({
  requestPage,
  encryptedResyAdsId,
  correlationId,
}) => amexOneDataFunctionsApi(correlationId).post(
  AMEX_PERSONALIZED_MARKETING_PAYLOAD,
  {
    requestPage,
    encryptedResyAdsId,
    clientPlatform: 'resy-web',
  }
);
export const getNotify = (data) => resyApiGet().get(NOTIFY_3, { params: data });
export const getAmexPrefillToken = () => resyApiGet().get(AMEX_PREFILL);
export const getCuisines = (data) => resyApiGet(data).get(LOCATION_CUISINES, { params: data });
export const getAmexPlatinumVenues = (data) => resyApiGet(data).get(AMEX_PLATINUM_VENUES, { params: data });
export const getSurvey = (data) => resySurveyGet().get(SURVEY(data));
// API PATCH
export const patchVenueToList = (data) => resyApiPatch({ contentType: JSON_ENCODED }).patch(VENUES_LISTS(data.venueId), {
  list_ids: data.list_ids,
});

// API POST
// https://github.com/resy/api#post
export const postAnnouncement = (data) => resyApiPost().post(ANNOUNCEMENT, parameterize(data));
export const postAuthRefresh = () => resyApiPost({ contentType: JSON_ENCODED, withCredentials: true }).post(AUTH_REFRESH);
// https://github.com/resy/api#post-61
export const postAuthEmailRequest = (data) => resyApiPost({ withCredentials: true }).post(AUTH_EMAIL_REQUEST, parameterize(data));
// https://github.com/resy/api#3authemailverify
export const postAuthEmailVerify = (data) => resyApiPost({ withCredentials: true }).post(AUTH_EMAIL_VERIFY, parameterize(data));
// https://github.com/resy/api#3authchallenge
export const postAuthChallenge = (data) => resyApiPost({ withCredentials: true }).post(AUTH_CHALLENGE, parameterize(data));
// https://github.com/resy/api#3authmobile
export const postAuthMobileClaim = (data) => resyApiPost().post(AUTH_MOBILE_CLAIM, parameterize(data));
export const postAuthMobile = (data) => resyApiPost({ withCredentials: true }).post(AUTH_MOBILE, parameterize(data));
// https://github.com/resy/api#3authpassword
export const postAuthPassword = (data) => resyApiPost({ withCredentials: true }).post(AUTH_PASSWORD, parameterize(data));
// https://github.com/resy/api/blob/master/README.md#post-63
export const postBookingBook = (data) => resyApiPostLegacy().post(BOOKING_BOOK, parameterize(data));
// https://github.com/resy/api/blob/master/README.md#post-66
export const postBookingBookConcierge = (data) => resyApiPostLegacy().post(BOOKING_CONCIERGE_BOOK, parameterize(data));
// https://github.com/resy/api/blob/master/README.md#post-65
export const postBookingChange = (data) => resyApiPostLegacy().post(BOOKING_CHANGE, parameterize(data));
// https://github.com/resy/api/blob/master/README.md#3details
export const postBookingDetails = (data) => resyApiPostLegacy({ contentType: JSON_ENCODED }).post(BOOKING_DETAILS, data);
export const postGoogleBookingDetails = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(GOOGLE_BOOKING_DETAILS, data);
export const postCancel = (data) => resyApiPost().post(CANCEL, parameterize(data));
export const postConciergeCancel = (data) => resyApiPost().post(CONCIERGE_CANCEL, parameterize(data));
// https://github.com/resy/api#3conciergespecial_request
export const postConciergeSpecialRequest = (data) => resyApiPost().post(CONCIERGE_SPECIAL_REQUEST, parameterize(data));
export const postConsumerGuestTags = (data) => resyOsPost().post(
  CONSUMER_GUEST_TAGS,
  { tags: handlePostConsumerGuestTagsParams(data) }
);
export const postConsumerNotes = (data) => resyOsPost().post(CONSUMER_NOTES, {
  note: {
    id: data.noteId || null,
    category_id: 1, // Food and beverage
    body: data.body,
    entity: {
      id: data.id,
      type_id: 4, // reservation
    },
    notable: false,
  },
});
export const postConsumerNotesList = (data) => resyOsPost().post(CONSUMER_NOTES_LIST, {
  entity: {
    id: data.partyId,
    type_id: 4, // reservation
  },
});
// https://github.com/resy/os/blob/master/README.md#post-67
export const postConsumerReservationPartyTags = (partyId, tags) => resyOsPost().post(CONSUMER_RESERVATION_PARTY_TAGS(partyId), { tags });
// https://github.com/resy/api#2contact
export const postContact = (data) => resyApiPost().post(CONTACT, data);
export const postCreateList = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(LISTS, data);
export const postDietaryNote = (data) => resyOsPost().post(CONSUMER_NOTES, {
  note: {
    id: data.noteId || null,
    category_id: 1, // Food and beverage
    body: data.body,
    entity: {
      id: data.id, // user's guest_id
      type_id: 1, // user
    },
    notable: false,
  },
});
export const postDietaryNotesList = (data) => resyOsPost().post(CONSUMER_NOTES_LIST, {
  entity: {
    id: data.id,
    type_id: 1, // user
  },
});
export const copyListBySlug = ({ slug, ...data }) => resyApiPost({ contentType: JSON_ENCODED }).post(`${LISTS_COPY_BY_SHARE_SLUG(slug)}`, { ...data });
export const setFollowListBySlug = (slug) => resyApiPost({ contentType: JSON_ENCODED }).post(`${LIST_FOLLOW_BY_SHARE_SLUG(slug)}`);
// https://github.com/resy/api#post-37
export const postAddVenueToList = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(VENUES_LISTS(data.venueId), {
  list_ids: data.list_ids,
});
export const postFavorites = (data) => resyApiPost().post(FAVORITES, parameterize(data));
// https://github.com/resy/api#2forgot_password
export const postForgotPassword = (data) => resyApiPost().post(FORGOT_PASSWORD, parameterize(data));
// https://github.com/resy/api#post-14
export const postHospitality = (data) => resyApiPost().post(HOSPITALITY, parameterize(data));
export const postOptimizelyExperiments = (userAttributes = { track_user_id: false }) => resyApiPost({ contentType: JSON_ENCODED }).post(OPTIMIZELY_FEATURE_FLAGS, userAttributes);
export const postOptimizelyTrackEvents = ({ slug, data }) => resyApiPost({ contentType: JSON_ENCODED }).post(`${OPTIMIZELY_EVENT_TRACKING(slug)}`, { ...data });
// https://github.com/resy/api#post-15
export const postNotify = (data) => resyApiPost().post(NOTIFY_3, parameterize(data));
export const postPartyInviteConfirm = (data) => resyApiPost().post(PARTY_INVITE_CONFIRM, parameterize(data));
export const postPartyInviteDecline = (token) => resyApiPost().post(PARTY_INVITE_DECLINE, parameterize({
  host_attendee_token: token,
}));
export const postPartyInviteGuests = (data) => resyApiPost().post(PARTY_INVITE_GUESTS, parameterize(data));
export const postProxyOsPrepay = (data = {}) => resyApiPost({ contentType: JSON_ENCODED }).post(PROXY_OS_PREPAY, {
  web_key: data.token,
  prepay: data,
});
export const postRateReservation = (data) => resyApiPost().post(
  RATE_RESERVATION,
  parameterize(handlePostRateReservationParams(data))
);
// https://github.com/resy/api#post-50
export const postRegisterUser = (data, captcha) => resyApiPost({ authToken: false, withCredentials: true }).post(USER_REGISTRATION, parameterize({ ...data, captcha_token: captcha }));
// https://github.com/resy/api#post-32
export const postReservationAddress = (data) => resyApiPost().post(RESERVATION_ADDRESS, parameterize(data));
// https://github.com/resy/api#post-33
export const postReservationSpecialRequest = (data) => resyApiPost().post(RESERVATION_SPECIAL_REQUEST, parameterize(data));
export const postStripePaymentMethod = (data) => resyApiPost().post(STRIPE_PAYMENT_METHOD, parameterize(data));
// https://github.com/resy/api/blob/master/README.md#post-75
export const postStripeSetupIntent = (venueId) => resyApiPost().post(STRIPE_SETUP_INTENT, venueId ? parameterize({ on_behalf_of: venueId }) : undefined);
export const postStripeConciergeSetupIntent = (data) => resyApiPost().post(STRIPE_CONCIERGE_SETUP_INTENT, parameterize(data));
export const postSurvey = (urlCode, data) => resySurveyPost({ contentType: JSON_ENCODED }).post((SURVEY(urlCode)), data);
export const postEditList = (data) => resyApiPost({ contentType: JSON_ENCODED }).post(LISTS_BY_LIST_ID(data.list_id), { name: data.name, description: data.description });
export const postGenerateShareableListLink = (listId) => resyApiPost({ contentType: JSON_ENCODED }).post(LISTS_BY_LIST_ID_SHARE(listId));
// https://github.com/resy/api#post-35
export const postUser = (data) => resyApiPost({ authToken: false }).post(USER, parameterize(data));
// https://github.com/resy/api#post-39
export const postUserLocation = (data) => resyApiPost().post(USER_LOCATION, parameterize(data));
// https://github.com/resy/api#post-40
export const postUserPaymentMethod = (data) => resyApiPost().post(USER_PAYMENT_METHOD, parameterize(data));
// https://github.com/resy/api#post-41
export const postUserProfileAllergies = (data) => resyApiPost().post(
  USER_PROFILE_ALLERGIES,
  parameterize(handlePostUserProfileAllergiesParams(data))
);
// https://github.com/resy/api#2userprofileemailopt_out
export const postUserProfileEmailOptout = (data) => resyApiPost().post(USER_PROFILE_EMAIL_OPTOUT, (parameterize({
  email_type_id: data.id,
  opt_in: data.optIn ? 1 : 0,
})));
export const postUserProfileConciergeRegistration = (data) => resyApiPost().post(USER_PROFILE_CONCIERGE_REGISTRATION, parameterize(data));
// https://github.com/resy/api#post-42
export const postUserProfileLocations = (data) => resyApiPost().post(
  USER_PROFILE_LOCATIONS,
  parameterize(handlePostUserProfileLocationsParams(data))
);
// https://github.com/resy/api#post-46
export const postUserProfileRatingOptout = (data) => resyApiPost().post(USER_PROFILE_RATING_OPTOUT, parameterize({
  unique_key: data.token,
}));
// https://github.com/resy/api#2userreset_password
export const postUserResetPassword = (data) => resyApiPost({ authToken: false }).post(
  USER_RESET_PASSWORD,
  parameterize(handlePostUserResetPasswordParams(data))
);
// https://github.com/resy/api#post-35
export const postUserWithAuth = (data) => resyApiPost().post(USER, data);
// https://github.com/resy/api/blob/master/README.md#3venuesearchsearch
export const postVenueSearch = (data, sessionId) => resyApiPost({ contentType: JSON_ENCODED, sessionId }).post(VENUE_SEARCH, data);

// API DELETE
export const deleteConsumerNotes = (data) => resyOsDelete().delete(CONSUMER_NOTES, {
  data: {
    note: {
      id: data.noteId,
      entity: {
        id: data.entityId,
        type_id: 4, // reservation
      },
    },
  },
});
export const deleteFollowListBySlug = (slug) => resyApiDelete().delete(LIST_FOLLOW_BY_SHARE_SLUG(slug));
export const deleteListById = (listId) => resyApiDelete().delete(LISTS_BY_LIST_ID(listId));
// https://github.com/resy/api#delete-1
export const deleteNotify = (data) => resyApiDelete().delete(`${NOTIFY_2}?${parameterize(data)}`);
export const deleteNotifies = (data) => resyApiDelete().delete(`${NOTIFIES}?${parameterize(data)}`);
export const deletePartyGuest = (data) => resyApiDelete().delete(
  `${PARTY_GUEST}?${parameterize({
    resy_token: data.resyToken,
    attendee_token: data.guestToken,
  })}`
);
// https://github.com/resy/api#delete-4
export const deleteUserPaymentMethod = (data) => resyApiDelete().delete(
  `${USER_PAYMENT_METHOD}?${parameterize({
    payment_method_id: data,
  })}`
);
export const deleteVenueFromList = (data) => resyApiDelete().delete(
  `${VENUES_LISTS(data.venueId)}?${parameterize({
    list_ids: data.listIds,
  })}`
);
export const deleteDietaryNote = (data) => resyOsDelete().delete(CONSUMER_NOTES, {
  data: {
    note: {
      id: data.noteId,
      entity: {
        id: data.entityId,
        type_id: 1, // user
      },
    },
  },
});

export const handleReservationCancel = (data = {}) => (data.concierge_resy_token ? postConciergeCancel(data) : postCancel(data));

export const handleReservationSpecialRequest = (data = {}) => {
  const postData = {};
  if ('occasionName' in data) {
    postData.occasion = data.occasionName;
    postData.occasion_id = data.occasionId;
  } else if (!data.conciergeResyToken) postData.description = data.request;

  if ('selections' in data) {
    postData.description = data.selections.specialRequest;
  }

  if (data.conciergeResyToken) {
    postData.concierge_resy_token = data.conciergeResyToken;
    postData.special_request = data.request;
    postConciergeSpecialRequest(postData);
  } else {
    postData.resy_token = data.resyToken;
    postReservationSpecialRequest(postData);
  }
};
